<template>
  <div class="pageDesigner-main main-box">
    <div class="pageDesigner-top">
        <div class="top-left">
          <img class="title-img" src="./img/layout.png">
          <span class="title-span">页面设计</span>
        </div>
        <div class="top-center">
          <span class="pageType-span"><i class="el-icon-s-platform"></i>网页端</span>
          <el-input v-model="temp.pageName" />
        </div>
        <div class="top-right">
          <el-button type="success" @click="test">测试</el-button>
          <el-button type="primary" @click="save">保存</el-button>
        </div>
    </div>
    <div class="pageDesigner-content">
      <div class="left-board">
        <div class="layoutTemplate-div">
          <div class="layoutTemplate-title">布局模板</div>
          <div class="layoutTemplate-content">
            <div class="layoutTemplate-info">{{temp.pageTemplateName}}</div>
            <el-button class="layoutTemplate-btn" type="primary" @click="handleChangeTemplateOpenDialog">更改模板</el-button>
          </div>
        </div>

        <!-- 布局模板 -->
        <el-dialog title="修改布局模板" :visible.sync="pageTemplateDialogVisible" :close-on-click-modal="false"  width="400px">
          <div class="main-box"  style="height: 100px;padding: 10px">
            <el-form ref="dataForm1" id="dataForm1" label-width="120px" label-suffix="：">
              <el-row :gutter="15">
                <el-col :span="24">
                  <el-form-item  label="控件类型">
                    <el-select v-model="pageTemplate" style="width: 100%">
                      <el-option  v-for="item in pageTemplate_list" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <xr-button type="primary" @click="changeTemplate">确定</xr-button>
            <xr-button type="default" @click="pageTemplateDialogVisible = false">取消</xr-button>
          </div>
        </el-dialog>


        <!-- -->
        <div class="layoutContent-title">
          <div class="title-h1">组件</div>
          <div class="title-remark">选择并拖动至相应位置</div>
        </div>

        <!-- -->
        <div  class="layoutContent-main">
          <el-scrollbar class="left-scrollbar">
            <div class="components-list">
              <div class="components-title">
                <svg-icon icon-class="component" />表单型组件
              </div>
              <draggable
                class="components-draggable"
                :list="formComponents"
                :group="{ name: 'componentsGroup', pull: 'clone', put: false }" :clone="cloneComponent"
                draggable=".components-item"
                :sort="false"
                @end="onEnd"
              >
                <div v-for="(element, index) in formComponents" :key="index" class="components-item">
                  <div class="components-body">
                    <svg-icon :icon-class="element.tagIcon" />
                    {{ element.itemLabel }}
                  </div>
                </div>
              </draggable>
            </div>

            <div class="components-list">
              <div class="components-title">
                <svg-icon icon-class="component" />区域型组件
              </div>
              <draggable
                class="components-draggable"
                :list="areaComponents"
                :group="{ name: 'componentsGroup', pull: 'clone', put: false }" :clone="cloneComponent"
                draggable=".components-item"
                :sort="false"
                @end="onEnd"
              >
                <div v-for="(element, index) in areaComponents" :key="index" class="components-item">
                  <div class="components-body">
                    <svg-icon :icon-class="element.tagIcon" />
                    {{ element.itemLabel }}
                  </div>
                </div>
              </draggable>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <div class="center-board">
        <el-scrollbar class="center-scrollbar">
          <el-row class="center-board-row" :gutter="centerGutter">
            <el-form
              :label-width="temp.labelWidth + 'px'">
              <draggable class="drawing-board" :list="temp.itemList" :animation="340" group="componentsGroup">
                <draggable-item
                  v-for="(element, index) in temp.itemList"
                  ref="draggableItem"
                  :title="element.itemRef"
                  :key="element.renderKey"
                  :item-list="temp.itemList"
                  :element="element"
                  :index="index"
                  :active-id="activeId"
                  :form-conf="temp"
                  @activeItem="activeFormItem"
                  @copyItem="drawingItemCopy"
                  @deleteItem="drawingItemDelete"
                />
              </draggable>
              <div v-show="!temp.itemList.length" class="empty-info">
                从左侧拖入或点选组件进行页面设计
              </div>
            </el-form>
          </el-row>
        </el-scrollbar>
      </div>
      <div class="right-board">
        <right-panel
          ref="rightPanel"
          :pageId="pageId"
          :activeData="activeData"
          :pageTemp="temp"
          @refreshTableStyle="refreshTableStyle"
        ></right-panel>
      </div>
    </div>
    <!-- 一般列表 -->
    <normal-table-template ref="normalTableTemplate" v-if="isNormalTableTemplateShow" @initPageInfo="initPageInfo"></normal-table-template>
  </div>
</template>

<script>
  import draggable from 'vuedraggable'
  import { areaComponents, formComponents } from './utils/config'
  import DraggableItem from './DraggableItem.vue'
  import render from './utils/render'
  import RightPanel from "./RightPanel";
  import NormalTableTemplate from './template/normalTable/index.vue'

  let tempActiveData

export default {
  name: "index.vue",
  data(){
    return {
      areaComponents,
      formComponents,
      pageTemplateDialogVisible: false,    //是否显示【布局模板】页面
      isNormalTableTemplateShow: false,          //是否显示【普通列表配置】页面
      pageId: '',                          //页面ID
      activeId: '',                        //当前选中的ID
      activeData: {                        //当前选中的map对象
        itemType: ''
      },
      centerGutter: 15,                    //中间的列
      temp: {
        pageName: '新建首页布局76',
        templateType: '',
        pageTemplateName: '',              //模板名称
        pageTemplate: '',                  //页面模板
        itemList: []
      },
      idGlobal: 100,                       //全局的id编号
      pageTemplate: '',                    //选择的页面模板
      pageTemplate_list: [],               //页面模板列表
    }
  },
  components: {
    draggable,
    DraggableItem,
    render,
    RightPanel,
    NormalTableTemplate
  },
  created() {
    let pageId = this.$router.currentRoute.query.id;
    this.pageId = pageId;
    this.initPageInfo();
  },
  methods: {
    //初始化页面信息
    initPageInfo(){
      let pageId = this.pageId;
      return this.request({
        method:'post',
        url:'/web/service',
        params:{
          'method':'tGenerateDesigner_getDesignerPageInfo',
          'id': pageId
        }
      }).then((response) =>{          //这里使用了ES6的语法
        // 请求成功返回的数据
        //如果返回编码不为0，提示失败语
        if(response.code != '0'){
          this.$message.error(response.msg);
          return false;
        }
        if(response.data.info){
          this.temp = response.data.info;
        }
        if(response.data.pageTemplate_list){
          this.pageTemplate_list = response.data.pageTemplate_list;
        }
        // if(response.data.idGlobal){
        //   this.idGlobal = parseInt(response.data.idGlobal);
        // }
      })
    },
    //拖拽结束后，会触发的方法，在[cloneComponent]方法之后。
    onEnd(obj, a) {
      console.log('+++onEnd++++++++++++');
      if (obj.from !== obj.to) {
        this.activeData = tempActiveData
        this.activeId = this.idGlobal
      }
    },
    activeFormItem(element) {
      console.log('+++activeFormItem++++++++++++');
      this.activeData = element
      this.activeId = element.temporaryId
    },

    drawingItemCopy(item, parent) {
      console.log('+++drawingItemCopy++++++++++++');
      let clone = JSON.parse(JSON.stringify(item))
      clone = this.createIdAndKey(clone)
      parent.push(clone)
      this.activeFormItem(clone)
    },
    //复制节点，在拖拽完成的时候触发
    cloneComponent(origin) {
      console.log('+++cloneComponent++++++++++++');
      const clone = JSON.parse(JSON.stringify(origin))
      clone.temporaryId = ++this.idGlobal
      clone.span = this.temp.span
      clone.renderKey = +new Date() // 改变renderKey后可以实现强制更新组件
      if (!clone.layout) clone.layout = 'colFormItem'
      if (clone.layout === 'colFormItem') {
        clone.vModel = `field${this.idGlobal}`
        clone.placeholder !== undefined && (clone.placeholder += clone.itemLabel)
        tempActiveData = clone
      } else if (clone.layout === 'rowFormItem') {
        delete clone.label
        clone.componentName = `row${this.idGlobal}`
        // clone.gutter = this.formConf.gutter todo
        tempActiveData = clone
      }
      return tempActiveData
    },

    drawingItemDelete(index, parent) {
      parent.splice(index, 1)
      this.activeData = {
        itemType: ''
      }
      this.activeId = ''
      this.$nextTick(() => {
        const len = this.temp.itemList.length
        if (len) {
          this.activeFormItem(this.temp.itemList[len - 1])
        }
      })
    },
    //刷新表格样式
    refreshTableStyle(){
      console.log('+++++++刷新表格样式+++++++++++++++++++++++=');
      console.log(this.activeData);
      if(!!this.activeData.itemRef){
        let itemRef = this.activeData.itemRef;
        console.log(this.$refs);

        this.$refs.draggableItem.forEach((e) =>{
          console.log(e);
          console.log(e.title);
          console.log(itemRef);
          if(e.$attrs.title == itemRef){
            console.log('找到了！');
            console.log(e);
            console.log(e.$refs[itemRef].configure);
            e.$refs[itemRef].getData()
          }
        })
        this.$nextTick(()=>{
          this.$refs[itemRef].getData();
        })
      }
      console.log('+++++++刷新表格样式+++++++++++++++++++++++=');
    },
    //测试
    test(){
      console.log('+++++++++++++++++++++++++');
      console.log(this.temp.itemList);
      console.log(this.temp);
      console.log(this);
      console.log('+++++++++++++++++++++++++');

    },
    //保存
    save(){
      let data = this.CommonUtils.createFormData(this.temp);
      data.append('listStr', JSON.stringify(this.temp.itemList));
      return this.request({
        method: 'post',
        url: '/web/service?method=tGenerateDesigner_savePageInfo',
        data: data
      }).then((response) =>{          //这里使用了ES6的语法
        // 请求成功返回的数据
        //如果返回编码不为0，提示失败语
        if(response.code != '0'){
          this.$message.error(response.msg);
          return false;
        }

        this.$message({
          message: '保存成功！',
          type: 'success',
          duration: 1500,
          onClose: () => {
            // todo
          }
        })
      })
    },
    //打开【修改模板】页面
    handleChangeTemplateOpenDialog(){
      this.pageTemplate = this.temp.pageTemplate;
      this.pageTemplateDialogVisible = true;
    },
    //修改页面模板
    changeTemplate(){
      this.pageTemplateDialogVisible = false; //关闭页面
      let pageTemplate = this.pageTemplate;
      // 保存
      return this.request({
        method: 'post',
        url: '/web/service?method=tGeneratePage_edit',
        params: {
          id: this.pageId,
          pageTemplate: pageTemplate
        }
      }).then((response) =>{
        if (response.code !== 0) {
          this.$message.error(response.msg)
        }
        //修改显示
        let pageTemplateName = '';
        let pageTemplate_list = this.pageTemplate_list;
        for(let i = 0; i < pageTemplate_list.length; i ++){
          if(pageTemplate_list[i]['value'] == pageTemplate){
            pageTemplateName = pageTemplate_list[i]['label']
          }
        }
        this.pageTemplate = pageTemplate;
        this.temp.pageTemplate = pageTemplate;
        this.temp.pageTemplateName = pageTemplateName;

        let categoryKeyId = '';
        let categoryKeyName = '';
        let categoryKeyCode = '';
        if(!!this.temp.categoryKeyId){
          categoryKeyId = this.temp.categoryKeyId
        }
        if(!!this.temp.categoryKeyId){
          categoryKeyName = this.temp.categoryKeyName
        }
        if(!!this.temp.categoryKeyCode){
          categoryKeyCode = this.temp.categoryKeyCode
        }

        //如果发生了改变，则做出相应的调整
        if(this.pageTemplate == 'normalTable'){  //如果是普通列表
          this.isNormalTableTemplateShow = true;
          this.$nextTick(()=>{
            this.$refs.normalTableTemplate.init(this.pageId) //初始化页面
          })
        }else if(this.pageTemplate == 'save'){  //如果是新增页面
          this.temp.dataServerKey1 = categoryKeyCode + '_save';
          this.temp.dataServerKey2 = categoryKeyCode + '_getPageInfo';
        }else if(this.pageTemplate == 'edit'){  //如果是修改页面
          this.temp.dataServerKey1 = categoryKeyCode + '_edit';
          this.temp.dataServerKey2 = categoryKeyCode + '_getPageInfo';
        }

      })




    }
  }
}
</script>

<style lang="scss">
  @import './css/pageDesigner.scss';
</style>



// WEBPACK FOOTER //
// src/components/PageDesigner/index.vue